var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAuth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.134 0 0 3.134 0 7C0 10.866 3.134 14 7 14C10.866 14 14 10.866 14 7C14 3.134 10.866 0 7 0Z",
    fill: "#4CAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2214 4.63086C10.4317 4.84114 10.4317 5.18207 10.2214 5.39236L6.11022 9.50353C6.00924 9.60451 5.87228 9.66124 5.72947 9.66124C5.58666 9.66124 5.4497 9.60451 5.34872 9.50353L3.58679 7.7416C3.37651 7.53131 3.37651 7.19038 3.58679 6.9801C3.79707 6.76981 4.13801 6.76981 4.34829 6.9801L5.72947 8.36128L9.45989 4.63086C9.67017 4.42057 10.0111 4.42057 10.2214 4.63086Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuth);
export default __webpack_public_path__ + "static/media/auth.2e8d8804859e8f18954e231e395e53dd.svg";
export { ForwardRef as ReactComponent };